import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DonatePage from "../pages/donate/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/donate",
    element: <DonatePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
